/**
 * OrbitPrint — the sign-in hero scene: Route + Relay + Network in one loop.
 * A document leaves your phone, is relayed through the OrbitPrint node, fans
 * out along the network to a location, and that printer lights and prints.
 * 12 s loop: first half prints at Office, second half at Store. Home is
 * offline to show that jobs simply wait. Pure SVG + CSS (orbit.css .ob-mix).
 */
export default function HeroScene() {
  return (
    <div className="orbit-stage" aria-label="How OrbitPrint works">
      <div className="ob-mix">
        <svg viewBox="0 0 640 260" fill="none" aria-hidden="true">
          <path className="thin" d="M84 130 H214" strokeDasharray="4 6" />
          <path className="thin" d="M266 130 C 330 130, 380 62, 446 62" strokeDasharray="4 6" />
          <path className="thin" d="M266 130 H446" strokeDasharray="4 6" />
          <path className="thin" d="M266 130 C 330 130, 380 198, 446 198" strokeDasharray="4 6" opacity=".45" />
          <path className="trail t-office" d="M84 130 H240 C 330 130, 380 62, 446 62" />
          <path className="trail t-store" d="M84 130 H240 H446" />

          <g className="phone-glow">
            <rect x="40" y="94" width="44" height="76" rx="8" fill="#182A45" stroke="#365281" strokeWidth="1.5" />
            <rect x="47" y="105" width="30" height="48" rx="2" fill="#0F1B2D" />
          </g>
          <text x="62" y="192" fill="#8E9FBB" fontFamily="IBM Plex Mono" fontSize="10" textAnchor="middle">YOU</text>

          <circle className="hubring" cx="240" cy="130" r="26" fill="#243C60" stroke="#365281" strokeWidth="1.5" />
          <circle cx="240" cy="130" r="12" stroke="#F1F4F9" strokeWidth="2" />
          <rect x="236" y="126" width="8" height="8" fill="#F1F4F9" />
          <circle cx="240" cy="118" r="2.4" fill="#2ED47A" />
          <text x="240" y="176" fill="#8E9FBB" fontFamily="IBM Plex Mono" fontSize="10" textAnchor="middle">ORBITPRINT</text>

          <circle className="stop s-office" cx="470" cy="62" r="22" />
          <rect x="458" y="56" width="24" height="12" rx="2" fill="#F1F4F9" /><rect x="463" y="51" width="14" height="5" fill="#F1F4F9" />
          <circle className="plamp l-office" cx="479" cy="62" r="2.2" fill="#2A4166" />
          <g className="page p-office"><rect x="461" y="68" width="18" height="14" rx="1.5" fill="#F1F4F9" /><path d="M464 72h12M464 75h9M464 78h11" stroke="#2A4166" strokeWidth="1.2" /></g>
          <text x="520" y="58" fill="#C3CFE0" fontFamily="IBM Plex Mono" fontSize="10">OFFICE</text>
          <text x="520" y="70" fill="#8E9FBB" fontFamily="IBM Plex Mono" fontSize="9">Epson L5290</text>
          <text className="printed x-office" x="520" y="84" fill="#2ED47A" fontFamily="Archivo" fontWeight="700" fontSize="10" letterSpacing="1.5">PRINTED</text>

          <circle className="stop s-store" cx="470" cy="130" r="22" />
          <rect x="458" y="124" width="24" height="12" rx="2" fill="#F1F4F9" /><rect x="463" y="119" width="14" height="5" fill="#F1F4F9" />
          <circle className="plamp l-store" cx="479" cy="130" r="2.2" fill="#2A4166" />
          <g className="page p-store"><rect x="461" y="136" width="18" height="14" rx="1.5" fill="#F1F4F9" /><path d="M464 140h12M464 143h9M464 146h11" stroke="#2A4166" strokeWidth="1.2" /></g>
          <text x="520" y="126" fill="#C3CFE0" fontFamily="IBM Plex Mono" fontSize="10">STORE</text>
          <text x="520" y="138" fill="#8E9FBB" fontFamily="IBM Plex Mono" fontSize="9">Receipt printer</text>
          <text className="printed x-store" x="520" y="152" fill="#2ED47A" fontFamily="Archivo" fontWeight="700" fontSize="10" letterSpacing="1.5">PRINTED</text>

          <g opacity=".5">
            <circle cx="470" cy="198" r="22" fill="#182A45" stroke="#2A4166" strokeWidth="1.5" />
            <rect x="458" y="192" width="24" height="12" rx="2" fill="#8E9FBB" /><rect x="463" y="187" width="14" height="5" fill="#8E9FBB" />
            <text x="520" y="194" fill="#C3CFE0" fontFamily="IBM Plex Mono" fontSize="10">HOME</text>
            <text x="520" y="206" fill="#8E9FBB" fontFamily="IBM Plex Mono" fontSize="9">offline · jobs wait</text>
          </g>

          <g className="doc to-office"><rect x="-9" y="-11" width="18" height="22" rx="2" fill="#F1F4F9" /><path d="M-4 -3h8M-4 2h8M-4 7h5" stroke="#0F1B2D" strokeWidth="1.6" /></g>
          <g className="doc to-store"><rect x="-9" y="-11" width="18" height="22" rx="2" fill="#F1F4F9" /><path d="M-4 -3h8M-4 2h8M-4 7h5" stroke="#0F1B2D" strokeWidth="1.6" /></g>
        </svg>
      </div>
    </div>
  );
}
